import { Link } from "react-router-dom";
import { categoryComics } from "@/mocks/comics";

export default function CategoryGallery() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 leading-tight" style={{ fontFamily: "var(--font-heading)" }}>
            精选<span className="text-accent-500">恋爱</span>·<span className="text-accent-500">奇幻</span>推荐
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Link to={`/comic/${categoryComics[0].id}`} className="group relative rounded-2xl overflow-hidden aspect-[3/4] lg:aspect-auto lg:h-[560px] block">
            <img
              src={categoryComics[0].coverImage}
              alt={categoryComics[0].title}
              title={`${categoryComics[0].title} - 韩漫屋主编强推`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            <div className="absolute bottom-6 left-6">
              <span className="inline-block bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-full mb-2">主编强推</span>
              <h3 className="text-2xl font-bold text-white mb-1">{categoryComics[0].title}</h3>
              <p className="text-sm text-white/70">{categoryComics[0].author} · {categoryComics[0].latestChapter}</p>
            </div>
          </Link>

          <div className="flex flex-col gap-6">
            {categoryComics.slice(1).map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group relative rounded-2xl overflow-hidden flex-1 min-h-[260px] block"
              >
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫屋精选推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-5 left-5">
                  <h3 className="text-xl font-bold text-white mb-1">{comic.title}</h3>
                  <p className="text-sm text-white/70">{comic.author} · {comic.latestChapter}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}